













  import { defineComponent } from 'vue'

  export default defineComponent({
    components: {
      OneSiteSectionsNodeList: () => import('~/components/organisms/siteSections/OneSiteSectionsNodeList.vue'),
    },
    props: {
      siteSection: {
        type: Object,
        required: true,
      },
    },
  })
